module.exports = __webpack_public_path__ + "img/tutorial_calendar_01.b136ab37.gif";